import React from 'react'
import STAFF_1 from '../../Work-Assets/AI_Logo.png';

function Logo({setLogo_set, setSuluhu}) {
    const log_btn = () =>{
        setLogo_set(false)
        setSuluhu(true)
    }
  return (
    <div className='logo_main'>
        <img src={STAFF_1} />
        <div onClick={log_btn} className='CTC'>
            CLICK TO CONTINUE
        </div>
    </div>
  )
}

export default Logo